/* tslint:disable */
var TTeaserState = (function ()
{
    "use strict";
    var api = <any>{};

    // Overrides TeaserSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };

    // Template logic splitter
    api.buildOptions = function (selections)
    {
        return TMultiOptions.buildTeaser(this, selections);
    };

    api.buildSelectionInnerView = function (__html, selection, selectionUpdated)
    {
        __html.push(TBuildLine.buildView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true }));
    };

    return api;
}());

window.TTeaserState = TTeaserState;